import React from 'react';
import PropTypes from 'prop-types';
import { StyledButton } from '../CommonComponents/Button';
import { Container, Icon, Title, Message } from './styles';

const ErrorPageView = ({ icon, title, message, button }) => (
  <Container>
    <Icon className={icon} />
    <Title>{title}</Title>
    <Message>{message}</Message>
    <StyledButton.Primary onClick={button.onClick}>{button.text}</StyledButton.Primary>
  </Container>
);

ErrorPageView.defaultProps = {
  icon: '',
  title: '',
  message: null,
  button: {
    text: '',
    onClick: () => {},
  },
};

ErrorPageView.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.node,
  button: PropTypes.shape({
    text: PropTypes.string,
    onClick: PropTypes.func,
  }),
};

export default ErrorPageView;
